const userRoles = ['user', 'admin', 'super-admin'];
const adminRoles = ['admin', 'super-admin'];
// const superAdminRoles = ['super-admin']

const ROUTES = {
  OVERVIEW: { roles: userRoles, pathname: '/' },
  CONVERSATIONS: { roles: userRoles, pathname: '/conversations' },
  RECORDS: { roles: userRoles, pathname: '/records' },
  TICKETS: { roles: userRoles, pathname: '/tickets' },
  PROFILE: { roles: userRoles, pathname: '/profile' },
  CALL_REQUESTS: { roles: userRoles, pathname: '/call-requests' },
  RECORD: { roles: userRoles, pathname: '/chat-history/:conversationId/:customerId/:agentId?' },
  ADMIN: { roles: adminRoles, pathname: '/admin' },
  OFLINE_CHAT: { roles: adminRoles, pathname: '/offline-chat' },
  REPORTS: { roles: adminRoles, pathname: '/reports' },
  AGENTS: { roles: adminRoles, pathname: '/agents' },
  SETTINGS: { roles: adminRoles, pathname: '/settings' },
  LOGS: { roles: adminRoles, pathname: '/logs' },
  TEAM: { roles: adminRoles, pathname: '/teams' },
  FORGOT_PASSWORD: { roles: adminRoles, pathname: '/forgot-password' },
  RESET_PASSWORD: { roles: adminRoles, pathname: '/reset-password/:id/:token' },
  WIDGET_SETTINGS: { roles: adminRoles, pathname: '/widget_settings' },
  SECURITY: { roles: adminRoles, pathname: '/security-settings' },
  SDK: { roles: adminRoles, pathname: '/sdk' },
  SCHEDULER: { roles: adminRoles, pathname: '/scheduler' },
  SETUP: { pathname: '/setup' },
  LOGIN: { pathname: '/auth/login' },
  FORBIDDEN: { pathname: 'forbidden' },
  TWOFA: { pathname: '/2fa', roles: userRoles },
  DOCUMENTS: { roles: adminRoles, pathname: '/verification' },
  ESIGNATURE: { roles: adminRoles, pathname: '/esignature' },
  ESIGNATURE_UPLOAD: { roles: adminRoles, pathname: '/esignature/upload' },
  ESIGNATURE_BUILD: { roles: adminRoles, pathname: '/esignature/:id/build' },
  ESIGNATURE_TEMPLATES: { roles: adminRoles, pathname: '/esignature/templates' },
  ESIGNATURE_TEMPLATE_UPLOAD: { roles: adminRoles, pathname: '/esignature/templates/upload' },
  ESIGNATURE_TEMPLATE_BUILD: { roles: adminRoles, pathname: '/esignature/templates/:id/build' }
};

export default Object.freeze(ROUTES);
